import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { Document360_ModuleContextService } from './Document360.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class Document360_widgetform_ComponentContextService {
  private readonly moduleContext: Document360_ModuleContextService;

  constructor(moduleContext: Document360_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'widgetform',
      type: ComponentType.form
    }
  }
}